<template>
	<transition
		name="fade"
		mode="out-in"
	>
		<router-view />
	</transition>
</template>

<script>
	export default {
		name: 'EmptyParentComponent',
		data() {
			return {}
		},
	}
</script>

<style lang="css" scoped></style>
